<template>
  <Drawer
    :title="`${currentRole.name}-菜单分配`"
    v-model="visible"
    width="750"
    :mask-closable="false"
    :closable="false"
    :styles="drawerStyles"
  >
    <Tree :data="treeData" show-checkbox check-directly multiple ref="tree"></Tree>
    <div class="drawer-footer">
      <Button style="margin-right: 8px" @click="cancel">取消</Button>
      <Button type="primary" :loading="submitLoading" @click="ok">确定</Button>
    </div>
  </Drawer>
</template>

<script>
  export default {
    name: 'RoleMenu',
    props: {
      currentRole: {
        type: Object,
        default: () => {
        }
      },
      platCode: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        visible: false,
        treeData: []
      }
    },
    methods: {
      cancel () {
        this.visible = false
      },
      async ok () {
        let checkedTree = this.$refs['tree'].getCheckedAndIndeterminateNodes() // 选中且半选的数组
        // 遍历树 有问题请联系罗伯特
        let changed = this.$utils.getDiffPlatRoleMenu(this.treeData, checkedTree)
        if (changed.length === 0) return
        let menuList = changed.map(it => {
          return {
            menuCode: it.menuCode,
            status: !it.valid
          }
        })
        let args = {
          menuList,
          roleId: this.currentRole.id
        }
        this.submitLoading = true
        let { succ } = await this.$http.updateRoleMenu(args)
        this.submitLoading = false
        if (succ) {
          this.$Message.success('更新角色菜单成功!')
          this.cancel()
        }
      },
      async getPlatMenuTree () {
        if (!this.visible) return
        let { data = [] } = await this.$http.queryRoleMenuTree({ platCode: this.platCode, roleId: this.currentRole.id })
        let treeData = this.$utils.getPlatMenuTree(`${this.platCode}-平台菜单`, data)
        this.treeData = treeData
      }
    },
    watch: {
      visible: {
        handler (c) {
          if (c) {
            this.getPlatMenuTree()
          }
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .drawer-footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }
</style>
